import React from 'react'
import  { withRouter } from "react-router-dom";
import styles from './BottomTabBar.module.css';

const BottomTab = (props)=>{


    const changeHandler= (route) =>{
       // console.log(props);
        props.history.push(route);
        window.scrollTo(0, 0);
    }
    return (
        <div className="bottomTabConatiner">
        <span className={props.location.pathname === '/' ? 
            'icon-container active' : 'icon-container'} onClick={()=> changeHandler('/')}>
          <i className="fas fa-home icon" ></i>
          <label className={styles.label}>Home</label>
        </span>
        <span className={props.location.pathname === '/heatMap' ? 
            'icon-container active' : 'icon-container'} onClick={()=> changeHandler('/heatMap')}>
         <i className="fas fa-map icon"></i>
        <label className={styles.label}>Heat Map</label>
        </span>
        <span className={props.location.pathname === '/news' ? 
            'icon-container active' : 'icon-container '} onClick={()=> changeHandler('/news')}>
          <i className="fas fa-newspaper icon" >
        </i><label className={styles.label}>News</label></span>     
  </div>
    );
}

export default withRouter(BottomTab);